import { i as e, r as t } from "./reusable-text.service-BRwTtG_l.js";
import { defineAsyncComponent as n } from "vue";
import { getI18n as r } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var i = {
	en: {
		reusableTextApi: {
			created: "Textbox created",
			updated: "ReusableText updated",
			notFound: "Textbox not found",
			requiredFields: "The reusable text box cannot be saved because mandatory information is missing."
		},
		reusableTextList: {
			newButton: "New textbox",
			name: "Search for textbox title or ID (internal)",
			deleteReusableText: "Delete",
			duplicate: "Duplicate",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading textbox",
			headerLabel: "Textbox title (internal)",
			headerTextContent: "Textbox content",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Textbox deleted",
			errorOnDeleting: "Error deleting",
			createReusableText: "Create textbox"
		},
		reusableText: {
			reusableTextLabel: "Textbox",
			newReusableText: "New textbox",
			messageDeleteReusableText: "Delete textbox",
			messageDeleteReusableTextTitle: "Are you sure you want to delete this textbox? It will be deleted wherever it is currently used.",
			deleteReusableText: "Delete",
			placeholder: "Select textbox",
			messageDeleted: "Textbox deleted",
			errorOnDeleting: "Error deleting the textbox",
			errorFailedLoadedReusableTextWithId: "Error getting the textbox",
			handledInLegacySystem: "This textbox is being handled in {source}. It cannot be edited in Vibe."
		},
		reusableTextEdit: {
			label: "Textbox title (internal)",
			counter: "Counter",
			editReusableText: "Edit textbox",
			messageSaved: "New textbox saved",
			messageUpdated: "Changes saved",
			type: "Type",
			typeDefault: "Default",
			typeConclusion: "CHIP-Conclusion",
			typeInfo: "Info",
			typeMinorWarning: "Minor warning",
			typeClearWarning: "Clear warning"
		}
	},
	de: {
		reusableTextApi: {
			created: "Textbox erstellt",
			updated: "Wiederverwendbares Textfeld aktualisiert",
			notFound: "Textbox nicht gefunden",
			requiredFields: "Die Textbox kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		reusableTextList: {
			newButton: "Neue Textbox",
			name: "Suchen nach Textbox-Titel (intern) oder ID der Textbox",
			deleteReusableText: "Löschen",
			duplicate: "Duplizieren",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Textbox wird geladen",
			headerLabel: "Textbox-Titel (intern)",
			headerTextContent: "Textbox-Inhalt",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Textbox gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createReusableText: "Textbox erstellen"
		},
		reusableText: {
			reusableTextLabel: "Textbox",
			newReusableText: "Neue Textbox",
			messageDeleteReusableText: "Textbox löschen",
			messageDeleteReusableTextTitle: "Willst du diese Textbox wirklich löschen? Sie wird überall gelöscht, wo sie derzeit verbaut ist.",
			deleteReusableText: "Löschen",
			placeholder: "Textbox auswählen",
			messageDeleted: "Textbox gelöscht",
			errorOnDeleting: "Es gab einen Fehler beim Löschen des ReusableTexts",
			errorFailedLoadedReusableTextWithId: "Es gab einen Fehler beim Abrufen des ReusableTexts",
			handledInLegacySystem: "Diese Textbox wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden."
		},
		reusableTextEdit: {
			label: "Textbox-Titel (intern)",
			counter: "Zähler",
			editReusableText: "Textbox bearbeiten",
			messageSaved: "Neue Textbox gespeichert",
			messageUpdated: "Änderungen gespeichert",
			type: "Typ",
			typeDefault: "Standard",
			typeConclusion: "CHIP-Fazit",
			typeInfo: "Info",
			typeMinorWarning: "Leichte Warnung",
			typeClearWarning: "Deutliche Warnung"
		}
	}
}, a = [{
	path: "/reusable-text",
	children: [
		{
			path: "",
			name: "reusable_text_list",
			component: () => import("./reusable-text-list.view-C5JUktKY.js").then((e) => e.n),
			meta: { requiredRight: "reusable-texts:navigate" }
		},
		{
			path: "new",
			name: "reusable_text_new",
			component: () => import("./reusable-text-edit.view-BES7_mPj.js").then((e) => e.n),
			props: () => ({
				title: r().t("reusableText.newReusableText"),
				backRoute: "/reusable-text"
			}),
			meta: { requiredRight: ["reusable-texts:navigate"] }
		},
		{
			path: ":id",
			name: "reusable_text_detail",
			component: () => import("./reusable-text-edit.view-BES7_mPj.js").then((e) => e.n),
			props: (e) => ({
				title: r().t("reusableTextEdit.editReusableText"),
				id: e.params.id,
				backRoute: "/reusable-text"
			}),
			meta: { requiredRight: ["reusable-texts:navigate"] }
		}
	]
}], o = n(() => import("./reusable-text-content-block-VrFQ9W74.js")), s = {
	messages: i,
	routes: a,
	contentBlocks: [{
		type: "REUSABLE_TEXT",
		label: "reusableText.reusableTextLabel",
		icon: "type",
		component: o,
		defaultValue: { type: "REUSABLE_TEXT" }
	}]
};
//#endregion
export { o as ReusableTextContentBlock, t as getEmptyReusableText, e as getReusableText, s as reusableTextModule };

//# sourceMappingURL=index.es.js.map